import { Departments } from './collections.enums'

export interface ICollectionBanner {
  src: string
  alt?: string
}

export interface ICollectionLink {
  title: string
  handle: string
  level?: number
  hasSubLinks?: boolean
  ownerTitle?: string
  banner?: ICollectionBanner
  deliveryWeek?: string
  week: number
  year: number
}

export interface ICollectionListRef {
  target: string
  ref: React.RefObject<HTMLDivElement>
}

export interface ICollectionLinksObject {
  Menu: ICollectionLink[]
}

export interface IDepartment {
  name: string
  id: Departments
  image: string
}
